import {
  CONTRACTFILES,
  CONTRACTFILES_ERROR,
  CONTRACTFILES_SUCCESS,
  CONTRACTFILESDETAIL,
  CONTRACTFILESDETAIL_ERROR,
  CONTRACTFILESDETAIL_SUCCESS
} from './ContractFiles.actions'

const initialState = {
  data: { Garanties: {}, Sanctions: {}, Finished: {} },
  details: { csvStructure: [], tableStructure: [] },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Contract Files's reducer.
 */
const contractFilesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CONTRACTFILES: {
      return { ...initialState, fetching: true }
    }
    case CONTRACTFILES_ERROR:
    case CONTRACTFILESDETAIL_ERROR: {
      return { ...state, error: payload.error }
    }
    case CONTRACTFILES_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case CONTRACTFILESDETAIL: {
      return { ...state, details: initialState.details, fetching: true }
    }
    case CONTRACTFILESDETAIL_SUCCESS: {
      return { ...state, details: payload, fetching: false, fetched: true }
    }
    default: {
      return state
    }
  }
}

export default contractFilesReducer
